module.exports = __webpack_public_path__ + "@/assets/img/logo.0bd16d7a.svg";